// extracted by mini-css-extract-plugin
module.exports = {"feedback":"FeedbackFile_feedback__3wyh0"};